import {NgModule} from '@angular/core';
import {YandexAdComponent} from './yandex-ad.component';
import {YandexFloorAdComponent} from './yandex-floor-ad.component';
import {YandexAdMainMobileHeaderComponent} from './yandex-ad-main-mobile-header.component';
import {YandexLentaMobileHeaderComponent} from './yandex-lenta-mobile-header.component';



@NgModule({
  declarations: [YandexAdComponent, YandexFloorAdComponent, YandexAdMainMobileHeaderComponent, YandexLentaMobileHeaderComponent],
  exports: [
    YandexAdComponent,
	YandexFloorAdComponent,
	YandexAdMainMobileHeaderComponent,
	YandexLentaMobileHeaderComponent

  ],
})

export class YandexAdModule { }
